/* eslint-disable indent */
import styled from 'styled-components';
const FoldersBtnContainer = styled.div`
    display: inline-flex;
    position: relative;
    ${({ theme: { breakpoint } }) => breakpoint.name !== 'xs'
        ? 'margin: 0 .25em;'
        : 'margin: 0 .3em;'
    }
    &:first-child {
        margin: 0;
    }
    button {
        padding: 0 .45em;
    }
    .indicator {
        position: absolute;
        right: -3px;
        top: -3px;
        z-index: 10;
    }
`;

const Icon = styled.span`
    color: var(--color-stone-text);
    font-size: 1.2em;
    margin: 0 0 0 0;
`;

const Text = styled.span`
    padding-left: .25em;
`;

const Link = styled.a`
    ${({ pullRight }) => `
        ${pullRight ? `margin-left: auto !important;` : ''}
    `}
    padding: 0 .45em !important;
    line-height: 1.9em;
`;

const Nav = styled.nav`
    display: flex;
    padding: 0 .45em 0.5em;
`;

export { FoldersBtnContainer, Icon, Link, Nav, Text };
